import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import React from 'react';
import ReactDOM from 'react-dom';
import 'slick-carousel';
import { translate } from '../react/utils/helpers';
import NewProducts from '../react/NewProductsHomepage';
export default {
  init: function init() {
    document.querySelector('#new-products-homepage') && ReactDOM.render( /*#__PURE__*/React.createElement(NewProducts, null), document.querySelector('#new-products-homepage'));

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    };

    var textConfirm = translate('Email saved with success', 'Courriel enregistré avec succès');
    var textSuccess = translate('Email saved with success', 'Courriel enregistré avec succès');
    var textError = translate('Error while saving, try again please.', "Erreur lors de l'engeristrement, veuillez réessayer.");

    if (getUrlParameter('CIMessage') === 'success') {
      $('.CIMessage').text(textSuccess);
      scrollToAnchor('home-newsletter');
    } else if (getUrlParameter('CIMessage') === 'confirm') {
      $('.CIMessage').text(textConfirm);
      scrollToAnchor('home-newsletter');
    } else if (getUrlParameter('CIMessage') === 'error') {
      $('.CIMessage').text(textError);
      scrollToAnchor('home-newsletter');
    }

    function scrollToAnchor(aid) {
      var aTag = $('#' + aid);
      setTimeout(function () {
        $('html,body').animate({
          scrollTop: aTag.offset().top - 200
        }, 'slow');
      }, 2000);
    }
  },
  finalize: function finalize() {
    if ($('#corrousel_ino')) {
      $('#corrousel_ino').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        prevArrow: '<i class="slick-prev fa fa-angle-left"></i>',
        nextArrow: '<i class="slick-next fa fa-angle-right"></i>',
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          }
        }, {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
          }
        }]
      });
    }

    if ($('#news')) {
      $('#news').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        prevArrow: '<i class="slick-prev fa fa-angle-left"></i>',
        nextArrow: '<i class="slick-next fa fa-angle-right"></i>',
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          }
        }, {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
          }
        }]
      });
    }
  }
};